export default {
    videoPreview: 'Přehled videa',
    buttonLabelUpload: 'Nahrát nové',
    buttonLabelVideo: 'Video',
    buttonLabelPhoto: 'Foto',
    generateMagic: 'Vytvořte magii',
    isUploadingText: 'Video se nahrává. Zachvilku to bude ...',
} as const;
